module.exports = __webpack_public_path__ + "img/java.751ff210.png";